import { Component } from '@angular/core';

@Component({
    selector: 'app-maintenance-v2',
    templateUrl: './maintenance-v2.component.html',
    styleUrls: ['./maintenance-v2.component.css'],
    standalone: false
})
export class MaintenanceV2Component {
  constructor() {}

  refreshScreen() {
    window.location.reload();
  }
}

